export const SEND_ALERT = 'SEND_ALERT'
export const CLOSE_ALERT = 'CLOSE_ALERT'
export const SUBMITTING_FORM = 'SUBMITTING_FORM'
export const FORM_SUBMITTED = 'FORM_SUBMITTED'
export const FORM_SUBMIT_FAILED = 'FORM_SUBMIT_FAILED'
export const SUBSCRIBING_USER = 'SUBSCRIBING_USER'
export const USER_SUBSCRIBED = 'USER_SUBSCRIBED'
export const FAILED_SUBSCRIBING_USER = 'FAILED_SUBSCRIBING_USER'
export const CHANGE_CURRENT_WORKOUT = 'CHANGE_CURRENT_WORKOUT'
export const ADDING_NEW_WORKOUT = 'ADDING_NEW_WORKOUT'
export const ADDED_NEW_WORKOUT = 'ADDED_NEW_WORKOUT'
export const ADDING_NEW_WORKOUT_FAILED = 'ADDING_NEW_WORKOUT_FAILED'
export const ADDING_NEW_SUPPLEMENT = 'ADDING_NEW_SUPPLEMENT'
export const ADDING_NEW_SUPPLEMENT_FAILED = 'ADDING_NEW_SUPPLEMENT_FAILED'
export const ADDED_NEW_SUPPLEMENT = 'ADDED_NEW_SUPPLEMENT'
export const FETCHING_SUPPLEMENTS = 'FETCHING_SUPPLEMENTS'
export const FETCHING_SUPPLEMENTS_FAILED = 'FETCHING_SUPPLEMENTS_FAILED'
export const FETCHED_SUPPLEMENTS = 'FETCHED_SUPPLEMENTS'



// WEBPACK FOOTER //
// ./src/constants/index.js